// extracted by mini-css-extract-plugin
export default {"loginBox":"AccountBox_loginBox__BON17"};